<template>
  <div
    class="sb-progress-bar"
    data-sb-regression="sb-progress-bar"
    :class="progressClass"
    data-test-id="progress-bar"
  >
    <div
      :style="progressFillStyles"
      class="sb-progress-bar__fill"
      data-test-id="progress-bar-fill"
    />
  </div>
</template>
<script>

export default {
  name: 'SbProgressBar',
  props: {
    /**
     * Value of the progress bar in between 0 and 1.
     */
    value: {
      type: Number,
      default: 0,
      validator: (val) => val >= 0 && val <= 1,
    },
    /**
     * Style variation
     * `success, primary, warning, error, disabled`
     */
    variation: {
      type: String,
      default: null,
      validator: (value) => value.match(/(success|primary|warning|error|disabled)/),
    },
    /**
     * Define whether the progress bar has a roundededge or not
     */
    rounded: {
      type: Boolean,
      default: true,
    },
    /**
     * Define progress bar heigh
     * `sm, md`
     */
    size: {
      type: String,
      default: 'md',
    },
    /**
     * Define whether the progress bar will have track or not
     */
    showTrack: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    progressClass() {
      const classes = [];
      if (this.variation) {
        classes.push(`sb-progress-bar--${this.variation}`);
      } else if (this.value === 1) classes.push('sb-progress-bar--success');

      if (this.rounded) {
        classes.push('sb-progress-bar--rounded');
      }

      if (this.size) {
        classes.push(`sb-progress-bar--${this.size}`);
      }

      if (this.showTrack) {
        classes.push(`sb-progress-bar--track`);
      }

      return classes;
    },
    progressFillStyles() {
      return {
        width: `${this.value * 100}%`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@src/components/ProgressBar/style/sb-progress-bar.scss';
</style>
